var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WaitModule } from '@/ui/modules/shared/components/WaitModule';
import { lazily } from 'react-lazily';
import { Route, Routes } from 'react-router-dom';
import { AuthRoute, BlockedAccess, ProtectedRoute, RequestSignIn, RouteHandler, useAuth, } from '@agentguru/auth';
import { redirectRoutesBlackList } from './constants';
import { routes } from './constants/routes';
var Shell = lazily(function () { return import('@/ui/layouts/Shell'); }).Shell;
var AgenciesRoutes = lazily(function () { return import('@/ui/modules/agency/routes'); }).AgenciesRoutes;
var CommissionRoutes = lazily(function () { return import('@/ui/modules/commission/routes'); }).CommissionRoutes;
var ServiceFeeRoutes = lazily(function () { return import('@/ui/modules/serviceFee/routes'); }).ServiceFeeRoutes;
export function AppRoutes() {
    var isLoading = useAuth().isLoading;
    if (isLoading) {
        return null;
    }
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(RouteHandler, { defaultPath: routes.agencies, accessDeniedPath: routes.accessDenied }) }), _jsx(Route, { path: routes.login, element: _jsx(WaitModule, { children: _jsx(AuthRoute, __assign({ loginPath: "/".concat(routes.login) }, { children: _jsx(RequestSignIn, {}) })) }) }), _jsxs(Route, __assign({ path: "/*", element: _jsx(WaitModule, { children: _jsx(ProtectedRoute, __assign({ blackList: redirectRoutesBlackList, pathName: routes.login }, { children: _jsx(Shell, {}) })) }) }, { children: [_jsx(Route, { path: "".concat(routes.agencies, "/*"), element: _jsx(AgenciesRoutes, {}) }), _jsx(Route, { path: "".concat(routes.commissions, "/*"), element: _jsx(CommissionRoutes, {}) }), _jsx(Route, { path: "".concat(routes.serviceFee, "/*"), element: _jsx(ServiceFeeRoutes, {}) })] })), _jsx(Route, { path: routes.accessDenied, element: _jsx(BlockedAccess, { appName: "control panel" }) })] }));
}
